export enum AudienceStatus {
  Active = 1,
  FinalizePending,
  FinalizeFailed,
  Finalized,
  ShippedPending,
  ShippedFailed,
  Shipped,
  Archived,
}
